// TOP-LEVEL IMPORTS
import React, { PureComponent } from 'react';
import styled from 'styled-components';
// MEDIA
import LoadingState from '../LoadingState';
import Lottie from 'react-lottie';
import * as animationData from 'lib/media/loading_animation.json';

// STYLED-COMPONENTS
// =========================
const Container = styled.div`
  height: 100%;
  width: 100%;
  background: ${p => p.theme.colorDark2};
`;

// EXPORTED COMPONENT
// =========================
class LoadingScreen extends PureComponent {
  render() {
    return (
      <Container theme={this.props.theme}>
        <LoadingState
          message={this.props.message}
          lottieloader={() => (
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice',
                },
              }}
              height={225}
              width={235}
            />
          )}
        />
      </Container>
    );
  }
}

// PROPS
// =========================
LoadingScreen.defaultProps = {
  message: ' ',
};

// EXPORT
// =========================
export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/components/common/LoadingScreen/index.js